export default {
    title: 'O Astrolink é ainda melhor no aplicativo!',
    subtitle: 'Desfrute da experiência completa com acesso fácil e rápido ao Astrolink no app',
    installButton: 'Instalar o aplicativo',
    notNowButton: 'Agora não'
};
